module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"forbidden":"Insufficient rights to access this information","goBackHome":"Go back to home page","goBackToPreviousPage":"Go back to previous page"},"fr":{"forbidden":"Droits insuffisants pour accéder à cette information","goBackHome":"Retour à l\u0027accueil","goBackToPreviousPage":"Retour à la page précédente"}}')
  delete Component.options._Ctor
}
